import { render, staticRenderFns } from "./ListKamiResult.vue?vue&type=template&id=1547776a&scoped=true&"
import script from "./ListKamiResult.vue?vue&type=script&lang=js&"
export * from "./ListKamiResult.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=1547776a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547776a",
  null
  
)

export default component.exports